import {serializable, alias, primitive} from 'serializr';
export class Target { 

	@serializable
	id?: number;

	@serializable(alias('is_sme', primitive()))
	isSME?: boolean;

	@serializable(alias('organization_id', primitive()))
	organizationId?: number;

	@serializable(alias('organization_name', primitive()))
	organizationName?: string;

	@serializable(alias('baseline_year', primitive()))
	baselineYear?: number;

	@serializable(alias('target_year', primitive()))
	targetYear?: number;

    @serializable(alias('target_name', primitive()))
	targetName?: string;

	@serializable(alias('target_category', primitive()))
	targetCategory?: string;

	@serializable(alias('target_type', primitive()))
	targetType?: string;

	@serializable(alias('target_coverage', primitive()))
	targetCoverage?: string;

    @serializable(alias('target_setting_method', primitive()))
	targetSettingMethod?: string;

	@serializable(alias('total_reduction', primitive()))
	totalReduction?: number;

	@serializable
	notes?: string;

}

export class ParentOrganization{
	@serializable
	id?: number;

	@serializable
	name?: string;
}
